import { compareAsc, compareDesc } from 'date-fns';

import { OrderBy } from '../model/order-by.model';
import { TranscriptCategories } from '../model/transcript-categories.model';

export function sortSummary(
    orderBy: OrderBy,
    categories: TranscriptCategories[],
): TranscriptCategories[] {
    return categories.map((c) => {
        const nextC = { ...c };

        nextC.subCategories = c.subCategories.map((sub) => {
            const nextSub = { ...sub };

            switch (orderBy) {
                case OrderBy.BY_DATE_MOST_RECENT:
                    nextSub.transcripts = [...nextSub.transcripts].sort(
                        (a, b) =>
                            compareDesc(a.createdDateTime, b.createdDateTime),
                    );
                    break;
                case OrderBy.BY_DATE_OLDEST:
                    nextSub.transcripts = [...nextSub.transcripts].sort(
                        (a, b) =>
                            compareAsc(a.createdDateTime, b.createdDateTime),
                    );
                    break;
                case OrderBy.ALPHABETICAL_A_TO_Z:
                    nextSub.transcripts = [...nextSub.transcripts].sort(
                        (a, b) =>
                            (a.title?.trim() ?? '').localeCompare(
                                b.title?.trim() ?? '',
                            ),
                    );
                    break;
                case OrderBy.ALPHABETICAL_Z_TO_A:
                    nextSub.transcripts = [...nextSub.transcripts].sort(
                        (a, b) =>
                            (b.title?.trim() ?? '').localeCompare(
                                a.title?.trim() ?? '',
                            ),
                    );
                    break;
            }

            return nextSub;
        });

        return nextC;
    });
}
